<template>
    <!-- 面包屑 -->
    <div>
        <Breadcrumb :style="{margin: '10px 0'}">
            <BreadcrumbItem v-for="(item,index) in breadcrumb" :key="index" :to="item.url">
                <Icon :size="item.size" :type="item.icon"></Icon>
                {{item.name}}
            </BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>

<script>
    export default {
        name: "breadcrumb",
        props: ['breadcrumb']
    }
</script>

<style scoped>

</style>